<template>
  <div class="py-3 px-4 bg-white rounded">
    <slot />
  </div>
</template>
